// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"673":"aa651cabafe06637212e","861":"48865552430263b0b8ce"}[chunkId] + ".js";
};